export * from './lib/component-loader.component';
export * from './lib/component-loader.models';
export * from './lib/component-loader.module';
